/**
 *
 */
// noinspection ES6UnusedImports
import * as bootstrap from 'bootstrap';

import './app/videos';
import setupOnLoad from './app/on-load';
import setupMainMenu from './app/main-menu';
import setupSlideshows from './app/slideshow';
import setupPhysiciansFilters from './app/physicians-filters';
import setupPhotoGalleries from './app/photo-gallery';
import setupPainAreas from './app/pain-areas';
import setupSiteNotifications from './app/site-notification';
import setupReadMore from './app/read-more';
import {addBootstrapColumnsToWpForm, addBootstrapFormFieldClassesToWpForms} from './app/utils/forms';

//import showScreenInfo from './dev/screen-info';


/**
 *
 */
window.addEventListener( 'DOMContentLoaded', () =>
{
	setupOnLoad();
	setupMainMenu();
	setupSlideshows();
	setupPhysiciansFilters();
	setupPhotoGalleries();
	setupPainAreas();
	setupSiteNotifications();
	addBootstrapFormFieldClassesToWpForms();
	setupReadMore();
	addBootstrapColumnsToWpForm( 2755, {
		1: 'col col-12 col-md-6',
		2: 'col col-12 col-md-6',
		4: 'col col-12 col-md-6',
		5: 'col col-12 col-md-6',
		6: 'col col-12 col-md-6',
		7: 'col col-12 col-md-6',
	} );
	//showScreenInfo(); // todo
} );